import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { Planning, PlanningType } from "../../types";
import { PrimayButton } from "../Button";
import { FormControl, Select, Stack, Text } from "@chakra-ui/react";
import { Label } from "../Label";

type Props = {
  planning?: Partial<Planning> | null;
  onSubmit: (values: Partial<Planning>) => void;
};

export const PlanningForm: React.FC<Props> = ({ planning, onSubmit }) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      id: planning?.id,
      dateTime: planning?.dateTime || new Date(),
      type: planning?.type || PlanningType.RECORDED_WORKOUT,
    },
    enableReinitialize: true,
    onSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack spacing="1rem" direction="column">
        <FormControl>
          <Label>{t("screens.client.planningModal.day")}</Label>
          <Text>{formik.values.dateTime?.toLocaleDateString()}</Text>
        </FormControl>

        <FormControl>
          <Label>{t("screens.client.planningModal.type")}</Label>
          <Select
            id="type"
            value={formik.values.type}
            onChange={formik.handleChange}
          >
            <option value={PlanningType.RECORDED_WORKOUT}>
              {t("screens.client.planningModal.types.RECORDED_WORKOUT")}
            </option>
            <option value={PlanningType.LIVE_WORKOUT}>
              {t("screens.client.planningModal.types.LIVE_WORKOUT")}
            </option>
            <option value={PlanningType.NO_WORKOUT}>
              {t("screens.client.planningModal.types.NO_WORKOUT")}
            </option>
          </Select>
        </FormControl>

        <PrimayButton type="submit">{t("screens.login.button")}</PrimayButton>
      </Stack>
    </form>
  );
};
